/**
 * Copyright IBM Corp. 2021
 *
 * This source code is licensed under the IBM Public License Version 1.0 found in the
 * LICENSE file in the root directory of this source tree.
 */
import TriDropablePlugin from "./TriDropablePlugin.js";
import TriZoomPlugin from "./TriZoomPlugin.js";
import TriPanPlugin from "./TriPanPlugin.js";
import TriNavPlugin from "./TriNavPlugin.js";
import TriLastPositionPlugin from "./TriLastPositionPlugin.js";
import TriLabelsPlugin from "./TriLabelsPlugin.js";
import TriLayersPlugin from "./TriLayersPlugin.js";
import TriSelectablePlugin from "./TriSelectablePlugin.js";
import TriHighlightPlugin from "./TriHighlightPlugin.js";
import TriPinPlugin from "./TriPinPlugin.js";

const pluginsRegistry = new Map();

function addPlugin(type, pluginClass) {
  pluginsRegistry.set(type, pluginClass);
}

function getPlugin(type) {
  return pluginsRegistry.get(type);
}

addPlugin( TriDropablePlugin.type, TriDropablePlugin );
addPlugin(TriZoomPlugin.type, TriZoomPlugin);
addPlugin(TriPanPlugin.type, TriPanPlugin);
addPlugin(TriNavPlugin.type, TriNavPlugin );
addPlugin(TriLastPositionPlugin.type, TriLastPositionPlugin);
addPlugin(TriLabelsPlugin.type, TriLabelsPlugin);
addPlugin( TriLayersPlugin.type, TriLayersPlugin );
addPlugin(TriSelectablePlugin.type, TriSelectablePlugin);
addPlugin(TriHighlightPlugin.type, TriHighlightPlugin);
addPlugin(TriPinPlugin.type, TriPinPlugin);

export default {
  addPlugin,
  getPlugin,
};
